// reducer.js
import {
  OPEN_CONFIRM_DIALOG,
  CLOSE_CONFIRM_DIALOG,
  SHOW_TOASTER,
  CLOSE_TOASTER,
  OPEN_MODAL,
  CLOSE_MODAL,
  OPEN_ALERT_MODAL,
  CLOSE_ALERT_MODAL,
} from "store/actionTypes/hfnDsActionTypes";

const initialState = {
  confirmDialog: {
    open: false,
    title: "",
    onCancel: undefined,
    onConfirm: undefined,
    content: undefined,
    confirmButtonProps: undefined,
    cancelButtonProps: undefined,
  },
  toaster: {
    display: false,
    summary: "",
    severity: "info",
    position: "top",
    detail: undefined,
  },
  modal: {
    open: false,
    title: "",
    component: "",
    props: undefined,
    width: "",
  },
  alertModal: {
    open: false,
    title: "",
    children: undefined,
  },
};

export default function hfnDsUiDetails(state = initialState, action) {
  switch (action.type) {
    /* ---------- Confirm Dialog ---------- */
    case OPEN_CONFIRM_DIALOG:
      return {
        ...state,
        confirmDialog: {
          ...state.confirmDialog,
          ...action.payload,
          open: true,
        },
      };
    case CLOSE_CONFIRM_DIALOG:
      return {
        ...state,
        confirmDialog: { ...state.confirmDialog, open: false },
      };

    /* ---------- Toaster ---------- */
    case SHOW_TOASTER:
      return {
        ...state,
        toaster: { ...initialState.toaster, ...action.payload, display: true },
      };
    case CLOSE_TOASTER:
      return {
        ...state,
        toaster: { ...state.toaster, display: false },
      };

    /* ---------- Modal ---------- */
    case OPEN_MODAL:
      return {
        ...state,
        modal: {
          ...state.modal,
          open: true,
          title: action.payload.title,
          component: action.payload.component,
          props: action.payload.props,
          width: action.payload.width,
        },
      };
    case CLOSE_MODAL:
      return {
        ...state,
        modal: { ...initialState.modal },
      };

    /* ---------- Alert Modal ---------- */
    case OPEN_ALERT_MODAL:
      return {
        ...state,
        alertModal: { ...state.alertModal, ...action.payload, open: true },
      };
    case CLOSE_ALERT_MODAL:
      return {
        ...state,
        alertModal: { ...state.alertModal, open: false },
      };

    default:
      return state;
  }
}
